import React, { useState } from "react";

// Renamed from useTodayDateRange 2026-08-26 - defaulting to "today only"
// was hiding real, already-created records the moment the clock ticked past
// midnight (reported live: 7 real LPOs from "yesterday" looked like they'd
// vanished). Now unbounded on load - both ends start blank, so every list
// shows everything the server returns (newest first) until the operator
// actively narrows it with these date inputs or any other filter/search on
// the page. The date-filter logic downstream already treats a blank
// dateFrom/dateTo as "no bound" (`!dateFrom || ...`), so leaving both blank
// here is enough - no other page logic needs to change to "keep all
// records by default." Plain <input type="date"> pair, matching this app's
// established date-range convention (see CustomerFieldVisitsPage.jsx)
// rather than introducing a new date-picker library.
export const useDateRangeFilter = () => {
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  return { dateFrom, setDateFrom, dateTo, setDateTo };
};

// Fixed, deliberately narrow widths (not the Bootstrap `.form-control`
// default of 100%, which is what was blowing the whole filter row onto
// multiple lines) - a date input never needs more than ~135px to show
// dd/mm/yyyy, so there's no reason to let it claim a flex-grow share.
const DateRangeFilter = ({ dateFrom, setDateFrom, dateTo, setDateTo }) => (
  <div className="d-flex gap-1 align-items-center flex-shrink-0">
    <input
      type="date"
      className="form-control form-control-sm"
      style={{ width: 135 }}
      value={dateFrom}
      max={dateTo || undefined}
      onChange={(e) => setDateFrom(e.target.value)}
    />
    <span className="text-muted small">to</span>
    <input
      type="date"
      className="form-control form-control-sm"
      style={{ width: 135 }}
      value={dateTo}
      min={dateFrom || undefined}
      onChange={(e) => setDateTo(e.target.value)}
    />
  </div>
);

export default DateRangeFilter;
